import React from 'react';
import { PaddingsMargins } from '../../../assets/styles/interface';
import { LocalizationProvider, PickerChangeHandlerContext, TimeValidationError } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TimePicker as TimePickerMaterial } from '@mui/x-date-pickers/TimePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { styled, FormHelperText } from '@material-ui/core';
import colors from '../../../assets/styles/colors';
import commons from '../../../assets/styles/commons';
import { Control, Controller } from 'react-hook-form';
import 'moment/locale/pt-br';
import { Moment } from 'moment';

interface Props extends PaddingsMargins {
  label: string;
  value: Moment | null;
  onChange: (time: Moment | null) => void;
  name?: string;
  control?: Control<any>;
  errorMessage?: string;
}

const TimePickerStyle = styled(TimePickerMaterial)(({ theme }) => ({
  '&.MuiInputBase-root': {
    position: 'relative',
    backgroundColor: colors.secondary.softBlue,
    border: '1px solid',
    borderColor: colors.primary.orange,
    flex: 1,
    width: 'auto',
    fontFamily: commons.fontFamily,
  },
  '&.MuiTextField-root': {
    backgroundColor: colors.secondary.softBlue,
  },
  '& .MuiInputBase-root-MuiOutlinedInput-root': {
    backgroundColor: colors.secondary.softBlue,
  },
}));

const Label = styled('div')({
  color: colors.primary.orange,
  fontFamily: commons.fontFamily,
  fontSize: '13px',
});

const TimePickerCustom: React.FC<Props> = ({
  label,
  name,
  control,
  errorMessage,
  value,
  ...props
}) => {
  return (
    <>
      <Controller
        name={name || ''}
        control={control}
        render={({
          field: { onChange, ref },
          fieldState: { error },
        }) => (
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <DemoItem label={<Label>{label}</Label>}>
              <TimePickerStyle
                slotProps={{ textField: { size: 'small' } }}
                sx={{
                  marginRight: props.mr,
                  marginLeft: props.ml,
                  marginTop: props.mt,
                  marginBottom: props.mb,
                }}
                ampm={false}
                onChange={(value: unknown, context: PickerChangeHandlerContext<TimeValidationError>) => props.onChange(value as Moment | null)}
                value={value}
                ref={ref}
              />
              {errorMessage && (
                <FormHelperText style={{ color: colors.error.intenseRed }}>
                  {errorMessage}
                </FormHelperText>
              )}
            </DemoItem>
          </LocalizationProvider>
        )}
      />
    </>
  );
};

export default TimePickerCustom;
